import { TwoFactorSmsPhonenumberChange } from "@/components/Portal/UserAccount/Security/Change/TwoFactorSmsPhonenumberChange";

export const TwoFactorChangeSmsView = () => {
  return (
    <div className="flex flex-col gap-4">
      <TwoFactorSmsPhonenumberChange />
    </div>
  );
};
